import { get, set } from '../../Foundation/cookie';

export class Login {
  /**
   * Creates a new instance of the Video class for handling HTML5 Video, Youtube Videos and 23Videos
   * @param {HTMLElement} element Video DOM element
   */
  constructor(element) {
    // Name, reference
    element.Login = this;

    // Settings
    this.settings = {
      ...this._settings,
      ...(element.dataset.login.length ? JSON.parse(element.dataset.login) : {}),
    };
    this.cookie = get(this.settings.cookie);

    // References
    this.username = element.querySelector('#UserNameTextBox');
    this.password = element.querySelector('#PasswordTextBox');
    this.button = element.querySelector('#LoginButton') || element.querySelector('#Button');
    this.btnState = element.querySelector('#ShowHidePassword');
    this.error = element.querySelector('#error');
    this.form = element.querySelector('form');
    this.remember = element.querySelector('input[type="checkbox"]');

    // Events
    if (this.username) {
      this.username.addEventListener('keydown', this._onInputKeyDown.bind(this));
    }

    if (this.password) {
      this.password.addEventListener('keydown', this._onInputKeyDown.bind(this));
    }

    if (this.btnState !== null) {
      let stateHandler = this._onTogglePasswordState.bind(this);
      this.btnState.addEventListener('click', stateHandler);
    }

    if (this.button !== null) {
      let submitHandler = this._onSubmit.bind(this);
      this.button.addEventListener('click', submitHandler);
    }

    if (this.cookie) {
      this.username.value = this.cookie;
      this.remember.checked = true;
    }
  }

  /**
   * _onPasswordKeyDown
   * Trigger a submittion if user presses enter within password-field
   * @param {Event} e  - Event interface
   */
  _onInputKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.button.click();
    }
  }

  /**
   * OnSubmit
   * Submit login request to server and get response
   * @param {Event} e - Event interface
   */
  _onSubmit(e) {
    if (this.remember.checked) {
      set(this.settings.cookie, this.username.value.trim(), 365);
    } else {
      set(this.settings.cookie, null, -1);
    }

    dataLayer.push({
      event: 'user-login-submit',
      method: 'onsite',
    });

    if (this.settings.ajax === 'true') {
      e.preventDefault();

      let request = new XMLHttpRequest(),
        data = new FormData(this.form);

      // Request
      request.onreadystatechange = () => {
        if (request.readyState === XMLHttpRequest.DONE) {
          if (request.status === 200) {
            let requestData = JSON.parse(request.responseText);
            if (requestData.loginError) {
              this.error.classList.remove('is-hidden');
            } else if (requestData.succesUrl) {
              this.error.classList.add('is-hidden');
              window.location.href = requestData.succesUrl;
            }
          } else {
            this.error.classList.remove('is-hidden');
          }
        }
      };

      request.open('POST', '/api/sitecore/LoginSpot/Login');
      request.send(data);
    }
  }

  /**
   * _onTogglePasswordState
   * Toggle password from hidden-state to cleartext-state
   * @param {Event} e - Event interface
   */
  _onTogglePasswordState() {
    if (this.password) {
      let type = this.password.getAttribute('type');
      switch (type) {
        case 'password':
          this.password.setAttribute('type', 'text');
          this.btnState.classList.remove('eva-eye-outline');
          this.btnState.classList.add('eva-eye-off-outline');
          break;
        default:
          this.password.setAttribute('type', 'password');
          this.btnState.classList.remove('eva-eye-off-outline');
          this.btnState.classList.add('eva-eye-outline');
          break;
      }
    }
  }

  /**
   * Settings
   * Component settings
   * @returns Object
   */
  get _settings() {
    return {
      ajax: false,
      cookie: 'RememberMeCookie',
    };
  }
}
